export default {
  "translation": {
    "card_application": "Solicitud de Tarjeta",
    "card_application_des": "Obtén una tarjeta Sonic y úsala en más de 44 millones de comerciantes habilitados para Visa en todo el mundo.",
    "spend_your_crypto_like_fiat": "Gasta tu cripto como fiat",
    "use_globally_across_borders": "Úsala globalmente, a través de fronteras",
    "ultra_low_trans_costs": "Costos de transacción ultra bajos",
    "seamless_and_secure": "Sin problemas y seguro",
    "two_factor_verification": "Verificación en dos pasos",
    "two_factor_verification_des": "Inicia sesión de forma segura usando correo electrónico, teléfono, biometría y/o aplicación de autenticador",
    "safety_pin": "PIN de Seguridad",
    "safety_pin_des": "Restringe el acceso a información privada configurando un PIN",
    "trans_3ds_verification": "Verificación 3DS",
    "trans_3ds_verification_des": "Autoriza compras antes de que sean procesadas",
    "additional_security": "Seguridad Adicional",
    "additional_security_des": "Configura fácilmente límites de tarjeta y otras características de seguridad en la aplicación",
    "get_your_redotpay_card_in_steps": "Obtén tu tarjeta Sonic en 3 simples pasos.",
    "get_your_redotpay_card_subtitle": "Gasta criptomonedas como dinero fiduciario: Aceptado en más de 44 millones de comercios con Visa habilitada en todo el mundo.",
    "continue_key": "Continuar",
    "bind_your_mobile_number": "Vincula tu número móvil",
    "complete_identity_verification": "Completa la verificación de identidad",
    "apply_a_virtual_or_physical_card": "Solicita una tarjeta virtual o física",
    "transactions": "Transacciones",
    "need_mobile_bind_confirm": "Necesitas vincular el móvil primero",
    "info": "Información",
    "card_trans_status_refund_pending": "Reembolso Pendiente",
    "card_trans_status_refund_success": "Reembolso Exitoso",
    "card_trans_status_refund_fail": "Reembolso Fallido",
    "card_trans_status_refund_wait": "Reembolso Esperando",
    "card_trans_status_pending": "Autorizado",
    "card_trans_status_cleared": "Aclarado",
    "card_trans_status_declined": "Declinado",
    "card_trans_status_canceled": "Revertido",
    "card_trans_status_refund": "Reembolso",
    "card_trans_status_refund_cancel": "Cancelar Reembolso",
    "refund": "Reembolso",
    "transaction_list": "Lista de Transacciones",
    "more": "Más",
    "top_questions": "Preguntas Más Frecuentes",
    "faq": "FAQ",
    "self_service": "Autoservicio",
    "support_center": "Centro de Soporte",
    "hello": "Hola",
    "updated_on": "Actualizado el",
    "chat_with_us": "Chatea Con Nosotros",
    "warning": "Advertencia",
    "security_option_change_alert_prompt": "Después de desvincular/modificar Google Authenticator/móvil/correo electrónico/PIN, los retiros y transferencias internas estarán deshabilitados y las transacciones de la tarjeta estarán limitadas a $1000 por transacción durante las próximas 24 horas por razones de seguridad.",
    "cancel": "Cancelar",
    "ok": "OK",
    "account_deletion_regret_promp": "La eliminación de la cuenta permite un período de arrepentimiento de 15 días. Cuando inicies sesión nuevamente dentro de los 15 días después de solicitar la eliminación, tu solicitud será cancelada y tu cuenta podrá continuar utilizándose normalmente.",
    "view_on_blockchain_explorer": "Ver en el explorador de blockchain",
    "biz_sn": "Número de Transacción",
    "type": "Tipo",
    "create_time": "Hora de Creación",
    "logout_confirm": "¿Estás seguro de que quieres cerrar sesión?",
    "wallet": "Billetera",
    "continue_with_google": "Continuar con Google",
    "insufficient_balance_deposit_guide": "Saldo insuficiente. Deposita activos o tus transacciones serán declinadas y se podrá cobrar una tarifa.",
    "to": "A",
    "bill_will_be_sent_to": "La declaración de facturación se enviará a",
    "bill_statement": "Declaración de Factura",
    "export_bill": "Exportar Declaración de Factura",
    "this_month": "Este Mes",
    "last_month": "El Mes Pasado",
    "last_3_month": "Los Últimos 3 Meses",
    "this_year": "Este Año",
    "last_year": "El Año Pasado",
    "customize": "Personalizar",
    "bill_export_success": "La declaración de facturación ha sido enviada a tu correo electrónico, por favor verifica",
    "bill_empty": "Tu factura está vacía",
    "channel": "Canal",
    "merchant_country": "País del Comerciante",
    "status": "Estado",
    "withdraw_detail": "Detalles de Retiro",
    "new_key": "Nuevo",
    "deposit": "Depositar",
    "withdraw": "Retirar",
    "single_limit": "Límite Único",
    "all": "TODO",
    "minimum": "Mínimo",
    "available": "Disponible",
    "received_amount": "Monto Recibido",
    "withdrawl": "Retiro",
    "network_fee": "Tarifa de Red",
    "register": "Registrarse",
    "register_login": "Registrarse/Iniciar Sesión",
    "login": "Iniciar Sesión",
    "email_Phone": "Correo Electrónico/Número de Teléfono",
    "email": "Correo Electrónico",
    "mobile": "Móvil",
    "next": "Siguiente",
    "or_continue_with": "O continuar con",
    "forgot_pw": "¿Olvidaste tu contraseña?",
    "welcome_to_redotpay": "¡Bienvenido a Sonic Pay!",
    "verify_code": "Verificar Código",
    "get_code": "Obtener código",
    "by_creating_an_account": "Al crear una cuenta aceptas nuestra",
    "privacy_policy": "política",
    "terms_conditions": "Términos y Condiciones",
    "and": "y",
    "modify_pin": "Cambiar PIN",
    "pin_subtitle": "El PIN de seguridad proporciona verificación rápida, facilitando la visualización de números de tarjeta e información CVV.",
    "password_set_first_login": "Primera sesión para establecer contraseña",
    "next_step": "Siguiente Paso",
    "confirm": "Confirmar",
    "username": "Nombre de Usuario",
    "password": "Contraseña",
    "send_code": "Enviar Código",
    "send_code_to": "El código será enviado a",
    "switch_option": "Cambiar Opción de Verificación",
    "mobile_verification": "Verificación Móvil",
    "email_verification": "Verificación de Correo Electrónico",
    "choose_verify_method": "Cambiar Opción de Verificación",
    "verify_pin": "PIN de Seguridad",
    "google_authenticator_verification": "Google Authenticator",
    "security": "Seguridad",
    "bound": "Vinculado",
    "unbound": "No Vinculado",
    "set": "Configurar",
    "unset": "Desconfigurar",
    "update_pw": "Cambiar Contraseña",
    "delete_account": "Cancelar Cuenta",
    "google_authenticator": "Google Authenticator",
    "google_authenticator_subtitle": "Google Authenticator protege tus retiros y cuenta.",
    "download_install": "Descargar",
    "download_install_prompt": "Primero necesitas descargar e instalar la aplicación de Autenticador (Google Authenticator)",
    "backup_key": "Clave de Respaldo",
    "save_backup_key": "Guarda esta clave de respaldo en un lugar seguro",
    "google_authenticator_code": "Código de Google Authenticator",
    "email_subtitle": "La verificación de correo electrónico protege tus retiros y cuenta.",
    "change_email": "Cambiar Correo Electrónico",
    "email_update": "Actualización de Correo Electrónico",
    "code": "Código",
    "mobile_subtitle": "La verificación móvil protege tus retiros y cuenta.",
    "change_mobile": "Cambiar Móvil",
    "mobile_update": "Actualización Móvil",
    "mobile_bind": "Vincular Teléfono Móvil",
    "email_bind": "Vincular Correo Electrónico",
    "old_password": "Contraseña Anterior",
    "new_password": "Nueva Contraseña",
    "new_password_confirm": "Confirmar Nueva Contraseña",
    "language": "Idioma",
    "appearance": "Apariencia",
    "logout": "Cerrar Sesión",
    "log_out_toast": "Has cerrado sesión",
    "set_pin": "PIN de Seguridad",
    "account_deletion_prompt_1": "Esta cuenta nunca será recuperada",
    "account_deletion_prompt_2": "Todos los subusuarios / otras cuentas creadas por esta cuenta serán eliminadas y no podrán ser recuperadas.",
    "account_deletion_prompt_3": "Todas las claves API asociadas con esta cuenta serán eliminadas.",
    "account_deletion_prompt_4": "Todos los retiros de divisas delegados y pendientes de esta cuenta serán cancelados.",
    "account_deletion_prompt_5": "Todas las funciones de transacción de esta cuenta estarán deshabilitadas.",
    "account_deletion_prompt_6": "Los activos no retirados de esta cuenta se considerarán como activos abandonados voluntariamente.",
    "account_deletion_prompt_7": "Después de solicitar la eliminación de la cuenta, puedes tener un período de retiro de 15 días. Si inicias sesión nuevamente dentro de los 15 días posteriores a la solicitud de eliminación, tu solicitud de eliminación será cancelada y la cuenta podrá continuar utilizándose normalmente.",
    "kyc_status_0": "No Enviado",
    "kyc_status_1": "Verificando...",
    "kyc_status_2": "Aprobado",
    "kyc_status_3": "Auditoría Fallida",
    "kyc_status_4": "Reenviado",
    "kyc_status_5": "Enviar a Superior",
    "personal_info_review": "Revisión de Información Personal",
    "additional_info_request": "Solicitud de información adicional",
    "verifying": "Verificando...",
    "form_submitted_will_review_asap_new": "Tu solicitud ha sido enviada para revisión manual. El proceso suele tardar de 3 a 5 días, pero puede tomar más tiempo ocasionalmente. Por favor, ten paciencia.",
    "get_verified": "Verificación de Identidad",
    "kyc_verified": "Identidad del Usuario Verificada",
    "approved": "Aprobado",
    "not_able_to_submit_identity": "Como parte de nuestro proceso de revisión integral, requerimos información adicional de ti para completar los procedimientos de Conoce a tu Cliente (KYC) y de prevención de lavado de dinero (AML).",
    "aml_review_failed": "Para proceder con tu solicitud, por favor haz clic en el botón de abajo para acceder y completar el formulario de Autodeclaración.",
    "aml_declaration_prompt": "Por favor, ten en cuenta que la falta de proporcionar el formulario solicitado dentro de los próximos 14 días resultará en la denegación de tu solicitud.",
    "verify_your_identity": "Verifica tu identidad",
    "get_identity_verified": "Verifica tu identidad para comprar y usar la tarjeta",
    "country_region": "País/Región",
    "given_name": "Nombre",
    "surname": "Apellido",
    "date_of_birth": "Fecha de Nacimiento",
    "document_type": "Tipo de Documento",
    "document_number": "Número de Documento",
    "given_name_intl": "Nombre(INTL)",
    "surname_intl": "Apellido(INTL)",
    "click_to_add_signature": "Haz clic para agregar firma",
    "rewrite": "Reescribir",
    "submit": "Enviar",
    "save": "Guardar",
    "accounts_are_not_available": "Las cuentas no están disponibles",
    "abandon_assets": "Abandonar activos de {{amount}} {{currency}}",
    "account_deletion_successful": "Eliminación de cuenta exitosa",
    "passwords_do_not_match": "Las contraseñas no coinciden",
    "password_reset_success": "Restablecimiento de contraseña exitoso",
    "password_confirm": "Confirmar Contraseña",
    "is_refund": "Reembolso",
    "total_debt": "Deuda Total",
    "your_account_is_in_arrears": "Tu cuenta está en mora. Por favor, deposita fondos suficientes para saldar el saldo. Tu cuenta/tarjeta será restaurada cuando tu saldo sea ≥10 USD después del pago de la deuda.",
    "repayment": "Reembolso",
    "debit_record": "Registro de Débito",
    "no_data": "Datos Vacíos",
    "payment": "Pago",
    "transaction_details": "Detalles de la Transacción",
    "transaction_date": "Fecha de Transacción",
    "transaction_id": "ID de Transacción",
    "view_linked_order": "Ver Pedido Vinculado",
    "rights_interests": "Derechos e Intereses",
    "transaction_limit": "Límite de Transacción",
    "deposit_withdraw": "Depositar & Retirar",
    "card_purchased_number": "Número de tarjetas disponibles para compra",
    "on_review_your_applicant": "Estamos revisando tu solicitud",
    "form_en_only": "El formulario solo se puede completar en inglés",
    "available_to_spend": "Disponible para gastar",
    "get_a_card": "Obtén una tarjeta Sonic y úsala en más de 44 millones de comerciantes habilitados para Visa en todo el mundo.",
    "virtual_card": "Tarjeta Virtual",
    "physical_card": "Tarjeta Física",
    "apply_card": "Solicitar Tarjeta",
    "enjoy_seamless_spending": "Gastar",
    "spend_and_withdraw": "Gastar y retirar en cajeros automáticos",
    "card_labeling": "Etiquetado de Tarjetas",
    "card_tag": "Etiqueta de Tarjeta",
    "edit_billing_address": "Dirección de Facturación",
    "government_issued_id": "ID emitido por el gobierno",
    "facial_recognition": "Reconocimiento Facial",
    "address": "Dirección",
    "personnel_information_details": "Detalles de Información Personal",
    "nation_list": "Lista de Naciones",
    "choose_channel": "Modo de Verificación",
    "mobile_channel_sms": "SMS",
    "mobile_channel_smsAliyunWhatsApp": "WhatsAPP",
    "card_application_order": "Orden de Solicitud de Tarjeta",
    "promo_code_optional": "Código Promocional (Opcional)",
    "promo_code": "Código Promocional",
    "billing_address": "Dirección de Facturación",
    "shipping_address": "Dirección de Envío",
    "shipping_to": "Envío a",
    "card_purchase_fee": "Tarifa de Compra de Tarjeta",
    "card_holder_name": "Nombre del Titular de la Tarjeta",
    "city": "Ciudad",
    "province_state": "Provincia/Estado",
    "postal_code": "Código Postal",
    "address_line1": "Dirección",
    "address_line2": "Dirección Línea 2",
    "please_fill_in_the_information_in_english": "El formulario solo se puede completar en inglés",
    "first_name": "Nombre",
    "last_name": "Apellido",
    "country_code": "Código de País",
    "card_application_list": "Lista de Solicitudes de Tarjeta",
    "buy_virtual_card": "Comprar Tarjeta Virtual",
    "buy_physical_card": "Comprar Tarjeta Física",
    "withdraw_list": "Lista de Retiros",
    "no_more_data": "No Hay Más Datos",
    "select_a_network": "Seleccionar una red",
    "please_select_network": "Por favor, selecciona una red",
    "select_a_network_ensure": "Asegúrate de que la red que elijas para depositar coincida con la red de retiro, o los activos pueden perderse.",
    "network": "Red",
    "card_management": "Gestión de Tarjetas",
    "freeze": "Congelar",
    "unfreeze": "Descongelar",
    "freeze_card_des": "Una vez que se habilita la función de bloqueo de tarjeta con un solo botón, no podrás usar esta tarjeta, pero no afectará a otras tarjetas. Si deseas cancelar la función de bloqueo de tarjeta con un solo botón, puedes habilitarla nuevamente aquí.",
    "freezing_trades": "Congelar una tarjeta produce un pedido fallido, causando fallas en la transacción o tarifas adicionales por transacciones declinadas",
    "unfreeze_your_card_desc": "Una vez que se deshabilita la función de bloqueo de tarjeta con un solo botón, podrás usar esta tarjeta nuevamente, y no afectará a otras tarjetas. Si deseas congelar la tarjeta, puedes hacerlo aquí nuevamente.",
    "card_tag_set_success": "Etiqueta de tarjeta configurada con éxito",
    "bill": "Factura",
    "setting": "Configuración",
    "limit": "Límite",
    "assets_list": "Lista de Activos",
    "empty_data": "Datos Vacíos",
    "deposit_list": "Lista de Depósitos",
    "date": "Fecha",
    "merchant_city": "Ciudad del Comerciante",
    "card_number": "Número de Tarjeta",
    "card_type": "Tipo de Tarjeta",
    "mcc": "MCC",
    "declined_reason": "Razón de Rechazo",
    "card_authorization_payment": "Pago de Autorización de Tarjeta",
    "declined_transaction_fee": "Tarifa de Transacción Rechazada",
    "verified": "Verificado",
    "notifications": "Notificaciones",
    "need_to_add_bill_address": "Necesita agregar dirección de facturación",
    "need_to_add_shipping_address": "La dirección de envío no puede estar vacía",
    "success": "Éxito",
    "welcome_redotpay": "¡Bienvenido a Sonic Pay!",
    "reset_pw_alert": "Después de cambiar la contraseña, el retiro y la transferencia interna estarán deshabilitados y las transacciones de tarjeta estarán limitadas a $1000 por transacción durante las próximas 24 horas por razones de seguridad",
    "no_more_records": "No Hay Más Registros",
    "add": "Agregar",
    "address_label": "Etiqueta de Dirección",
    "add_address": "Agregar Dirección",
    "this_field_is_required": "Este campo es requerido",
    "ID_CARD": "Tarjeta de Identidad",
    "PASSPORT": "Pasaporte",
    "DRIVERS": "Licencia de Conducir",
    "RESIDENCE_PERMIT": "Permiso de Residencia",
    "amount": "Monto",
    "withdraw_status_waiting": "Esperando",
    "withdraw_status_pending": "Pendiente",
    "withdraw_status_success": "Éxito",
    "withdraw_status_fail": "Fallido",
    "withdraw_status_canceled": "Cancelado",
    "withdraw_status_declined": "Declinado",
    "withdraw_status_complete": "Completo",
    "order_id": "ID de Pedido",
    "click_or_scroll_to_load_more": "Haz clic o desplázate para cargar más",
    "minimum_deposit_amount": "Monto Mínimo de Depósito",
    "deposit_arrival_confirmations": "Llegada del depósito: {{confirmations}} confirmaciones",
    "confirmations": "{{confirmations}} Confirmaciones",
    "deposit_network": "Red de Depósito",
    "minimum_deposit": "Depósito Mínimo",
    "deposit_arrival": "Llegada del Depósito",
    "current_address_supports_depositing": "La dirección actual solo admite depósitos de {{varietyCode}} en {{displayName}}, y otros activos se perderán.",
    "copy_successful": "Copia Exitosa",
    "update_password_successful": "Actualización de Contraseña Exitosa",
    "update_successful": "Actualización Exitosa",
    "successful": "Exitoso",
    "signature_required": "Firma Requerida",
    "deposit_successful": "Depósito Exitoso",
    "sign_out": "Cerrar Sesión",
    "cancel_withdraw_order_success": "Cancelación de Pedido de Retiro Exitosa",
    "delete_successful": "Eliminación Exitosa",
    "unfreeze_card_successful": "Descongelar Tarjeta Exitosa",
    "card_nickname_set_successful": "Apodo de Tarjeta Establecido Exitosamente",
    "trans_limit_adjusted_success": "Límite de Transacción Ajustado Exitosamente",
    "set_card_pin_success": "Configuración del PIN de Tarjeta Exitosa",
    "withdraw_apply_commit_please_wait": "Solicitud de retiro enviada, por favor espera",
    "unfreeze_success": "Descongelar Exitoso",
    "freeze_success": "Congelación Exitosa",
    "withdraw_duration_tip": "Las solicitudes de retiro se procesarán dentro de un día hábil",
    "you_will_withdraw": "Retirarás",
    "withdraw_info": "Información de Retiro",
    "please_confirm_same_network": "Asegúrate de que la red que elijas para depositar coincida con la red de depósito, o los activos pueden perderse.",
    "cancel_withdraw_order_confirm": "¿Estás seguro de que deseas cancelar el retiro?",
    "valid_thru": "válido hasta",
    "last_7_days": "Últimos 7 Días",
    "last_30_days": "Últimos 30 Días",
    "today": "Hoy",
    "all_done": "Todo Hecho",
    "view_details": "Ver Detalles",
    "withdraw_success": "Retiro Exitoso",
    "pay": "Pagar",
    "fee": "tarifa",
    "discount": "Descuento",
    "price": "Precio",
    "card_application_details": "Detalles de Solicitud de Tarjeta",
    "card_pin": "PIN de Tarjeta",
    "card_pin_format_helper": "No puede contener tres números idénticos consecutivos o números secuenciales",
    "digit_variable": "{{count}} dígito",
    "address_book": "Libreta de Direcciones",
    "unlimited": "Ilimitado",
    "single": "Único",
    "update_card_pin": "Actualizar PIN de Tarjeta",
    "set_card_pin": "Establecer PIN de Tarjeta",
    "report_lost": "Reportar Pérdida",
    "report_lost_card": "Reportar tarjeta perdida",
    "card_lost_report_alert": "Después de reportar como perdida, la tarjeta será desactivada y no podrás cambiar el estado. Si deseas usar la tarjeta nuevamente o solicitar una nueva tarjeta, comunícate con el equipo de servicio al cliente.",
    "pending": "Pendiente",
    "frozen": "Congelado",
    "phone_number": "Número de Teléfono",
    "search": "Buscar",
    "reset": "Restablecer",
    "total_amount": "Monto Total",
    "actual_amount": "Monto Real",
    "already_have_an_account": "¿Ya tienes una cuenta?",
    "create_account": "Crea una Cuenta en Sonic Pay",
    "total_balance": "Saldo Total",
    "cards_balance_available_promp": "Límite de crédito calculado en tiempo real según los activos de la billetera",
    "got_it": "Entendido",
    "review_details": "Revisar Detalles",
    "delete_this_address": "¿Estás seguro de que deseas eliminar esta dirección?",
    "currency": "Moneda",
    "merchant_name": "Nombre del comerciante",
    "request_time": "Hora de la solicitud",
    "is_transaction_allowed": "¿Se permite esta transacción?",
    "approve": "Aprobar",
    "decline": "Rechazar",
    "card_in_production": "Tarjeta en producción",
    "redotpay_card_sent": "Tarjeta Redotpay enviada",
    "redotpay_card_activated": "Tarjeta Redotpay activada",
    "activate_card": "Activar tarjeta",
    "paste": "Pegar",
    "fees_included": "Tarifas Incluidas",
    "fx_fee": "Tarifa FX",
    "small_auth_fee": "Tarifa de transacción pequeña",
    "atm_fee": "Tarifa de cajero automático",
    "received": "Recibido",
    "incremental": "Incremental",
    "bill_address_save_success": "Dirección de facturación guardada correctamente",
    "no_more_trans_record": "No hay más registros de transacciones",
    "withdraw_amount_larger_than_available": "Sobrepasa el máximo saldo disponible",
    "withdraw_lower_than_min": "Por debajo del mínimo de retiro",
    "card_is_deleted": "Tarjeta eliminada",
    "something_error": "Algo salió mal",
    "home": "Inicio",
    "select_country": "Seleccionar País",
    "billing_list": "Lista de facturas",
    "coupon_code": "código de descuento",
    "password_rule1": "De 8 a 32 caracteres",
    "password_rule2": "Al menos una letra mayúscula inglesa",
    "password_rule3": "Al menos una letra minúscula inglesa",
    "password_rule4": "Al menos un número",
    "set_pw": "Configurar contraseña",
    "payment_currency_settings": "Configuración de la moneda de pago",
    "customize_payment_currency": "Personalizar moneda de pago",
    "disable_non_local_tip": "Desactivar transacciones en monedas no locales puede reducir eficazmente el riesgo de fraude con tarjetas.",
    "charging_rules": "Reglas de cobro",
    "reissue_card": "Reemitir tarjeta",
    "update_cvv": "Actualizar CVV",
    "update_cvv_desc": "El mismo número de tarjeta con un nuevo CVV y nueva fecha de vencimiento.",
    "reissue_fee": "Tarifa de reemisión",
    "fx_fee_desc": "La tarifa de cambio de divisas (FX) incluye una tarifa del 1.2% para transacciones en monedas no predeterminadas (si corresponde).",
    "atm_fee_desc": "Se aplicará una tarifa adicional del 2% por cada retiro en cajero automático.",
    "remit_fee_desc": "Tarifa por el uso de tarjetas de crédito o débito Visa.",
    "risk_safety_tips": "Consejos de seguridad",
    "risk_safety": "Por razones de seguridad, complete la verificación facial en la aplicación antes de proceder con cualquier operación relacionada.",
    "go_to_app_verify": "Ir a la aplicación para verificar",
    "register_download_app_title": "Sonic card service is ending. If you're a Sonic cardholder, you can get a free virtual card when you switch to RedotPay.",
    "register_download_app_desc": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "get_your_free_card": "Get your free card",
    "register_download_app_title_ended": "Sonic card services have now moved to RedotPay. If you're a Sonic cardholder, you can get a free virtual card when you register with RedotPay.",
    "register_download_app_desc_ended": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "go_to_redotpay": "Go to RedotPay",
    "go_to_redotpay_now": "Ir a RedotPay ahora",
    "close": "Cerrar",
    "card_cancellation": "Cancelación de tarjeta",
    "delete_card": "Eliminar tarjeta",
    "delete_card_desc": "Una vez eliminada, la tarjeta no estará disponible y esta acción no se puede revertir.",
    "deleting_fee": "Tarifa de eliminación",
    "currency_tips": "Consejos sobre monedas",
    "at_least_one_currency": "Mantenga al menos una moneda habilitada para pagos.",
    "all_select_currency": "Ya admite transacciones en todas las monedas.",
    "small_auth_transaction_fee_stas": "Detalles de las tarifas de transacciones pequeñas",
    "small_transactions_this_month": "Transacciones pequeñas este mes",
    "small_autn_trans_remain": "Número de exenciones de tarifa para transacciones pequeñas este mes",
    "rules": "Reglas",
    "failed_rules": "Las transacciones fallidas aumentan el registro de transacciones defectuosas y, si excede el límite, se cobrarán tarifas adicionales. Realice las transacciones de manera adecuada.",
    "rule_item": "Elemento",
    "free_count": "Conteo gratuito",
    "fees": "Tarifas",
    "declined_trans_remain": "Número de exenciones de tarifa para transacciones rechazadas este mes",
    "declined_transaction_fee_stats": "Estadísticas de tarifas de transacciones rechazadas",
    "declined_rules": "Las transacciones fallidas aumentan el registro de transacciones defectuosas y, si excede el límite, se cobrarán tarifas adicionales. Realice las transacciones de manera adecuada.",
    "declined_transactions_this_month": "Transacciones rechazadas este mes",
    "card_trans_detail_status_refund": "Reembolso en proceso",
    "card_trans_status_reversal": "Reversión",
    "card_trans_status_fully_refund": "Procesado, reembolso completo",
    "card_trans_status_partial_refund": "Procesado, reembolso parcial",
    "card_trans_status_void": "Nulo",
    "first_time_free": "Primera vez gratis",
    "FxFee": "Tarifa de cambio de divisas",
    "AtmFee": "Tarifa de cajero automático",
    "RemitFee": "Tarifa de remesas",
    "MccFee": "Tarifa MCC",
    "mcc_fee_desc": "Algunos comerciantes aplicarán una tarifa adicional del 1.5% del monto de la transacción. Si la tarifa es inferior a 0.5 USD, se aplicará una tarifa mínima de 0.5 USD.",
    "please_deposit": "Por favor, haga un depósito",
    "special_mcc_fee": "Tarifa MCC especial",
    "bank_verifying": "Este reembolso está siendo revisado por el banco…",
    "estimate_time": "Tiempo estimado de llegada: 2-30 días",
    "delete_out": "Cerrar sesión",
    "card_is_loss": "La tarjeta ha sido reportada como perdida",
    "incremental_desc": "Si el monto autorizado es insuficiente, se aplicarán cargos adicionales y el monto correspondiente se añadirá al momento de la liquidación.",
    "card_trans_status_fully_refund1": "Liquidado",
    "card_trans_status_fully_refund2": "Reembolsado Totalmente",
    "card_trans_status_partial_refund1": "Liquidado",
    "card_trans_status_partial_refund2": "Reembolsado Parcialmente",
    "review_takes_time": "La revisión toma de 2 minutos a 24 horas.",
    "custom_date_null": "Por favor, seleccione una fecha personalizada",
    "custom_date_error": "Por favor, configure el tiempo de consulta correcto",
    "small_trade_fee": "Tarifa de transacción pequeña",
    "user_risk_exception": "Excepción de estado de usuario",
    "request_exception": "Error en la solicitud",
    "mobile_is_not_empty": "Por favor, introduzca un número de móvil válido",
    "code_is_not_empty": "Por favor, introduzca un código de verificación válido",
    "browser_paste_error": "Restricciones del navegador, por favor ingrese manualmente"
  }
};